import { MdOutlineRemoveCircle } from 'react-icons/md';
import { FeatureReqBody } from '../../../types/features';

const AddFeatureModalTable = ({
  selectedFeatures,
  removeSelectedFeatureHandler,
}: {
  selectedFeatures: Array<FeatureReqBody>;
  removeSelectedFeatureHandler: (featureName: string) => void;
}) => {
  // rendering add feature modal table component here
  return (
    <div className='min-w-[500px] border-2 border-dashed border-legal-dark-blue rounded-lg'>
      <div className='grid grid-cols-[220px_1fr_50px] border-b-2 border-legal-dark-blue border-dashed font-semibold text-legal-dark-blue [&>p]:py-1 text-center [&>p]:border-r [&>p]:border-r-base-dark-blue [&>p]:border-dashed'>
        <p>Feature Name</p>
        <p>Description</p>
      </div>

      <div className='[&>div:not(:last-child)]:border-b [&>div:not(:last-child)]:border-legal-dark-blue [&>div:not(:last-child)]:border-dashed'>
        {selectedFeatures.map((feature, index) => (
          <div
            key={index}
            className='relative grid grid-cols-[220px_1fr_50px] text-center text-base-dark-blue [&>div:not(:last-child)]:border-r [&>div:not(:last-child)]:border-legal-dark-blue [&>div:not(:last-child)]:border-dashed [&>div]:p-1'
          >
            <div>
              <p title={feature.name} className='truncate'>
                {feature.name}
              </p>
            </div>

            <div>
              <p title={feature.description} className='truncate'>
                {feature.description}
              </p>
            </div>

            <div className='flex items-center justify-center'>
              <button
                title='Remove Feature'
                type='button'
                onClick={() => removeSelectedFeatureHandler(feature.name)}
                className='hover:opacity-70 duration-300'
              >
                <MdOutlineRemoveCircle className='size-5 text-base-red' />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AddFeatureModalTable;
